<template>
	<div class="notice_content">
		<div class="notice_wrap">
			<div class="content-wrap">
				<div class="wrap1 flex-center" @click="openMessageModal">
					<div class="boxl">
						<img class="noticeImg" src="@/assets/images/home/pc/notice.png" alt="" />
						<span class="box2">最新消息</span>
					</div>
					<div class="boxr">
						<div class="marquee-wrapper">
							<div class="marquee-text">
								{{ messageInfo.content }}
							</div>
							<div class="marquee-text">
								{{ messageInfo.content }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 消息弹窗 -->
		<div v-if="showModal" class="modal" @click="handleOutsideClick">
			<div class="modal-content" ref="modalContent">
				<span class="close-btn" @click="closeMessageModal">&times;</span>
				<h3>系統公告</h3>
				<ul class="message-list">
					<li v-for="(message, index) in messageList" :key="message.id" class="message-item">
						<h4 class="message-title">{{ message.title }}</h4>
						<p class="message-content">{{ message.content }}</p>
						<small class="message-time">{{
					formatTime(message.addtime)
					}}</small>
						<hr />
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import { web_index, system_notice } from "@/api/index";
	export default {
		data () {
			return {
				messageList: [],
				messageInfo: {},
				currentMessageIndex: 0, // 当前显示的消息索引
				showModal: false, // 控制弹窗的显示和隐藏
				timer: null, // 用于定时轮播
				num: 1
			}
		},
		mounted() {
			this.getSystemNotice();
			this.startCarousel(); // 页面加载时启动轮播
			this.numAnimation(
				this.num1,
				parseInt(this.getFixedSixDigitNumber()).toString(),
				this,
				"num1"
			);
		},
		beforeDestroy() {
			this.stopCarousel(); // 组件销毁时停止轮播
		},
		methods: {
			/**
			 * 数字过渡动画-目前版本-默认一秒之内完成过渡动画
			 * @param current number 当前值
			 * @param target number 目标值
			 * @param _this 传递 当前实例指向 this
			 * @param property string _this 和 property 是因为要把需要改变的属性传递进去，因为函数传参基础数据类型是值拷贝而不是值引用
			 * @param step number 当前版本支持 1 0.1 0.01 分别对应 整数变化、一位小数、两位小数
			 */
			numAnimation(
				current,
				target,
				_this,
				property,
				step = 1,
				totalTime = 2500,
				duration = 20,
				timer = ""
			) {
				clearInterval(timer);
				let ternialStep = 0;
				if (target >= current) {
					ternialStep = (target - current) / (totalTime / duration);
				} else {
					ternialStep = (current - target) / (totalTime / duration);
				}
			
				if (ternialStep > 10) {
					ternialStep = parseInt(ternialStep).toString().split("");
					ternialStep[ternialStep.length - 1] = 1;
					ternialStep = parseInt(ternialStep.join(""));
				} else {
					ternialStep = Math.ceil(ternialStep) || 1;
				}
				if (current < target) {
					timer = setInterval(() => {
						if (step === 0.1) {
							_this[property] =
								(_this[property] * 1000 + (step + ternialStep) * 1000) / 1000;
						} else if (step === 0.01) {
							_this[property] =
								(_this[property] * 1000 + (step + ternialStep) * 1000) / 1000;
						} else {
							_this[property] = _this[property] + ternialStep;
						}
						if (_this[property] >= target) {
							_this[property] = target;
							clearInterval(timer);
						}
					}, duration);
				} else if (current > target) {
					timer = setInterval(() => {
						if (step === 0.1) {
							_this[property] =
								(_this[property] * 1000 - (step + ternialStep) * 1000) / 1000;
						} else if (step === 0.01) {
							_this[property] =
								(_this[property] * 1000 - (step + ternialStep) * 1000) / 1000;
						} else {
							_this[property] = _this[property] - ternialStep;
						}
						if (_this[property] <= target) {
							_this[property] = target;
							clearInterval(timer);
						}
					}, duration);
				}
			},
			getCurrentDateFormatted() {
				// 获取当前日期
				const date = new Date();
			
				// 提取年份、月份和日期
				const year = date.getFullYear();
				let month = date.getMonth() + 1; // 月份从0开始，所以要加1
				let day = date.getDate();
			
				// 格式化月份和日期，使其总是两位数
				month = month < 10 ? "0" + month : month;
				day = day < 10 ? "0" + day : day;
			
				// 拼接成所需的格式
				return `${year}${month}${day}`;
			},
			
			hashStringToSixDigitNumber(str) {
				// 使用 FNV-1a 哈希算法
				let hash = 2166136261;
				for (let i = 0; i < str.length; i++) {
					hash ^= str.charCodeAt(i);
					hash +=
						(hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
				}
			
				// 将哈希值转化为正整数并取最后六位数字
				const hashStr = Math.abs(hash).toString();
				return hashStr.slice(-6).padStart(6, "0");
			},
			getFixedSixDigitNumber() {
				const dateStr = this.getCurrentDateFormatted();
				return this.hashStringToSixDigitNumber(dateStr);
			},
			getSystemNotice() {
				let params = {};
				system_notice(params)
					.then((res) => {
						if (res.code == 0) {
							this.messageList = res.data;
							this.messageInfo = res.data[0];
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {});
			},
			startCarousel() {
				this.timer = setInterval(() => {
					this.currentMessageIndex =
						(this.currentMessageIndex + 1) % this.messageList.length;
				}, 5000); // 每3秒切换一次消息
			},
			stopCarousel() {
				if (this.timer) {
					clearInterval(this.timer);
				}
			},
			openMessageModal() {
				this.showModal = true;
			},
			closeMessageModal() {
				this.showModal = false;
			},
			handleOutsideClick(event) {
				// 如果点击的目标不是弹窗内容，关闭弹窗
				if (!this.$refs.modalContent.contains(event.target)) {
					this.closeMessageModal();
				}
			},
			// 格式化时间戳为可读格式
			formatTime(timestamp) {
				const date = new Date(timestamp * 1000); // 假设addtime是秒
				return date.toLocaleString();
			},
		}
	}
	
	
	
</script>

<style lang="scss" scoped>
	.notice_content{
		width: 100%;
		
		.notice_wrap{
			width: 100%;
			display: flex;
			justify-content: center;
			
			.content-wrap {
				width: 100%;
				padding-top: 30px;
			
				.wrap1 {
					width: 100%;
					height: 60px;
					background: #f8f4f0;
					border-radius: 10px;
					padding: 0 17px;
					cursor: pointer;
			
					.boxl {
						width: 130px;
						float: left;
						display: flex;
						align-items: center;
			
						/* 垂直居中（如果需要） */
						.noticeImg {
							flex-shrink: 0;
							width: 30px;
							height: 30px;
							margin-right: 7px;
						}
			
						.box2 {
							font-size: 17px;
							color: #333;
							font-weight: 600;
						}
			
					}
			
					.boxr {
						width: 90%;
						font-size: 17px;
						overflow: hidden;
						white-space: nowrap;
						box-sizing: border-box;
			
						.marquee-wrapper {
							width: 100%;
							/* 或者你需要的特定宽度 */
							overflow: hidden;
							white-space: nowrap;
							box-sizing: border-box;
							position: relative;
							/* 确保子元素相对于此元素定位 */
						}
			
						.marquee-text {
							display: inline-block;
							padding-left: 100%;
							/* 初始时，文本完全在容器外部 */
							animation: marquee 25s linear infinite;
							/* 动画设置 */
						}
			
						@keyframes marquee {
							0% {
								transform: translateX(0);
							}
			
							100% {
								transform: translateX(-100%);
							}
						}
					}
				}
			}
		}
		
		.modal {
			display: block;
			position: fixed;
			z-index: 1;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.5);
		}
				
		.modal-content {
			background-color: #f8f4f0;
			margin: 10% auto;
			padding: 20px;
			width: 60%;
			/* 固定宽度 */
			max-height: 70%;
			/* 固定弹窗最大高度 */
			overflow-y: auto;
			/* 当内容超出时显示滚动条 */
			border-radius: 8px;
			/* 圆角样式 */
			box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
		}
				
		.close-btn {
			color: red;
			float: right;
			font-size: 24px;
			cursor: pointer;
		}
				
		h3 {
			margin-bottom: 15px;
			font-size: 20px;
			text-align: center;
		}
				
		.message-list {
			list-style-type: none;
			padding: 0;
			margin: 0;
		}
				
		.message-item {
			padding: 10px 0;
		}
				
		.message-title {
			font-size: 18px;
			/* 较大的字体用于标题 */
			font-weight: bold;
			margin-bottom: 5px;
		}
				
		.message-content {
			font-size: 16px;
			/* 中等大小字体用于内容 */
			margin-bottom: 5px;
		}
				
		.message-time {
			font-size: 14px;
			/* 较小的字体用于时间 */
			color: #888;
		}
				
		hr {
			border: none;
			border-top: 1px solid #eee;
			/* 分割线 */
			margin: 10px 0;
		}
				
		/* 过渡效果：淡入淡出和滑动 */
		.fade-slide-enter-active,
		.fade-slide-leave-active {
			transition: all 0.5s ease;
		}
				
		.fade-slide-enter,
		.fade-slide-leave-to {
			opacity: 0;
			transform: translateX(0px);
			/* 消息滑动进入/退出 */
		}
				
		.message-title1 {
			display: flex;
			flex: 1;
			justify-content: center;
			align-items: center;
			font-size: 17px;
			white-space: nowrap;
			/* 防止消息换行 */
			overflow: hidden;
		}
	}
</style>